module.exports = __webpack_public_path__ + "img/banner5.61b49dfc.png";